import angular from 'angular';

let MiscFactory = angular.module('MiscFactory', [])
						 .factory('MiscFactory', ($rootScope, $http, HttpFactory, URLS) =>{
							 'ngInject';
							 return {
								 getYears: () =>{
									 return HttpFactory.get(URLS.YEARS);
								 },
								 getStates: () =>{
									 return HttpFactory.get(URLS.STATES);
								 },
								 getCounties: () =>{
									 return HttpFactory.get(URLS.COUNTIES);
								 },
								 getRegions: () =>{
									 return HttpFactory.get(URLS.REGIONS);
								 },
								 getNationalities: () =>{
									 return HttpFactory.get(URLS.NATIONALITIES);
								 },
							 };
						 }).name;

export default MiscFactory;



// WEBPACK FOOTER //
// ./client/app/services/misc.factory.js